<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="footer-main__container container">
        <div class="footer-main__top">
          <NuxtLinkLocale to="/" class="footer-main__top-logo" aria-label="Logo">
            <ElementsLogo />
          </NuxtLinkLocale>
          <div class="footer-main__top-social">
            <span>{{ $t("footer.socialTitle") }}</span>
            <a v-for="item in social" :key="item.title" :href="item.link" class="footer-main__top-social-icon" :aria-label="item.title">
              <Icon :name="item.icon" />
            </a>
          </div>
        </div>
        <div class="footer-main__content">
          <div class="footer-main__navigation">
            <nav v-for="group in menuGroups" :key="group.title" class="footer-main__group">
              <div class="footer-main__group-title">{{ group.title }}</div>
              <ul class="footer-main__group-links">
                <li v-for="link in group.links" :key="link.link">
                  <NuxtLinkLocale :to="link.link">{{ link.title }}</NuxtLinkLocale>
                </li>
              </ul>
            </nav>
          </div>
          <form class="footer-main__newsletter" @submit.prevent="submitNewsletter">
            <div class="footer-main__newsletter-label">{{ $t("footer.newsletterLabel") }}</div>
            <div class="footer-main__newsletter-input">
              <ElementsFormInput name="email" type="email" :placeholder="$t('footer.newsletterPlaceholder')" v-model="email" />
              <ElementsButton tag="button" type="submit">
                <Icon name="ri:send-plane-2-line" />
              </ElementsButton>
            </div>
            <ElementsFormCheckbox name="terms" v-model="termsAccepted">
              <a href="/page/kisisel-verilerin-korunmasi-ve-islenmesi">{{ $t("footer.kvkk") }}</a>
              {{ $t("common.and") }}
              <a href="/page/kisisel-verilerin-korunmasi-ve-islenmesi">{{ $t("footer.membershipAgreement") }}</a>
              {{ $t("footer.newsletterTerms") }}
            </ElementsFormCheckbox>
          </form>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom__container container">
        <div class="footer-bottom__copyright">{{ $t("common.copyright", { year: new Date().getFullYear() }) }}</div>
        <a class="footer-bottom__agency" href="https://sivene.com" target="_blank">
          <svg data-logo viewBox="0 0 883 229">
            <path
              fill="currentColor"
              d="M72.288 228.96C65.376 228.96 58.464 228.48 51.552 227.52C44.64 226.752 38.016 225.6 31.68 224.064C25.344 222.528 19.488 220.608 14.112 218.304C8.736 215.808 4.032 213.12 0 210.24L6.624 177.12H7.776C11.04 182.304 14.88 187.68 19.296 193.248C23.904 198.816 28.992 204 34.56 208.8C40.128 213.408 46.08 217.248 52.416 220.32C58.752 223.2 65.28 224.64 72 224.64C84.864 224.64 94.944 221.856 102.24 216.288C109.536 210.528 113.184 201.888 113.184 190.368C113.184 181.344 110.592 173.856 105.408 167.904C100.224 161.952 93.696 156.672 85.824 152.064C77.952 147.264 69.408 142.752 60.192 138.528C51.168 134.304 42.72 129.408 34.848 123.84C26.976 118.272 20.448 111.648 15.264 103.968C10.08 96.288 7.488 86.688 7.488 75.168C7.488 65.76 9.312 57.408 12.96 50.112C16.8 42.624 21.984 36.384 28.512 31.392C35.04 26.208 42.72 22.272 51.552 19.584C60.384 16.896 69.888 15.552 80.064 15.552C94.08 15.552 106.272 17.28 116.64 20.736C127.2 24.192 136.608 28.704 144.864 34.272L137.952 68.832H136.512C134.016 63.264 130.848 57.6 127.008 51.84C123.168 46.08 118.752 40.8 113.76 36C108.768 31.2 103.296 27.36 97.344 24.48C91.584 21.408 85.44 19.872 78.912 19.872C67.008 19.872 57.696 22.944 50.976 29.088C44.256 35.232 40.896 43.2 40.896 52.992C40.896 59.328 42.432 64.896 45.504 69.696C48.576 74.304 52.608 78.528 57.6 82.368C62.784 86.016 68.544 89.472 74.88 92.736C81.408 96 88.032 99.36 94.752 102.816C101.664 106.08 108.288 109.632 114.624 113.472C121.152 117.312 126.912 121.824 131.904 127.008C137.088 132 141.216 137.856 144.288 144.576C147.36 151.104 148.896 158.88 148.896 167.904C148.896 177.312 147.072 185.76 143.424 193.248C139.968 200.736 134.88 207.168 128.16 212.544C121.632 217.728 113.664 221.76 104.256 224.64C94.848 227.52 84.192 228.96 72.288 228.96 M202.178 50.688C195.074 50.688 189.026 48.192 184.034 43.2C179.042 38.208 176.546 32.16 176.546 25.056C176.546 18.144 179.042 12.288 184.034 7.48801C189.026 2.496 195.074 0 202.178 0C205.634 0 208.802 0.672003 211.682 2.01601C214.754 3.36 217.346 5.184 219.458 7.48801C221.762 9.6 223.586 12.192 224.93 15.264C226.274 18.336 226.946 21.6 226.946 25.056C226.946 28.512 226.274 31.872 224.93 35.136C223.586 38.208 221.762 40.896 219.458 43.2C217.346 45.504 214.754 47.328 211.682 48.672C208.802 50.016 205.634 50.688 202.178 50.688ZM171.362 226.944V225.216C175.01 223.68 177.602 220.704 179.138 216.288C180.674 211.68 181.442 206.976 181.442 202.176V117.504C181.442 110.976 180.194 105.792 177.698 101.952C175.394 97.92 172.034 94.08 167.618 90.432V88.992C170.498 88.032 174.242 86.88 178.85 85.536C183.458 84.192 188.354 82.752 193.538 81.216C198.722 79.488 203.906 77.856 209.09 76.32C214.274 74.592 218.786 73.152 222.626 72H223.778V202.176C223.778 206.976 224.546 211.68 226.082 216.288C227.81 220.704 230.498 223.68 234.146 225.216V226.944H171.362Z M313.317 76.032V77.76C308.133 79.872 304.485 82.944 302.373 86.976C300.261 91.008 300.933 96.864 304.389 104.544L337.509 178.848L371.493 105.12C374.565 98.784 374.661 93.504 371.781 89.28C369.093 85.056 364.485 81.216 357.957 77.76V76.032H400.293V77.76C394.149 80.832 389.445 84.288 386.181 88.128C383.109 91.968 380.517 96.096 378.405 100.512L319.077 226.944H316.485L260.613 104.256C257.925 98.496 255.237 93.408 252.549 88.992C249.861 84.384 246.021 80.64 241.029 77.76V76.032H313.317Z M473.465 70.56C485.369 70.56 495.545 72.288 503.993 75.744C512.633 79.008 519.641 83.616 525.017 89.568C530.585 95.328 534.713 102.144 537.401 110.016C540.089 117.696 541.433 126.048 541.433 135.072V138.816H442.649C442.649 148.224 443.705 157.152 445.817 165.6C448.121 173.856 451.385 181.152 455.609 187.488C460.025 193.632 465.401 198.528 471.737 202.176C478.265 205.824 485.657 207.648 493.913 207.648C501.209 207.648 508.601 206.4 516.089 203.904C523.577 201.408 530.681 196.032 537.401 187.776L538.265 189.216C535.385 194.592 532.217 199.68 528.761 204.48C525.305 209.28 521.081 213.504 516.089 217.152C511.289 220.8 505.529 223.68 498.809 225.792C492.281 227.904 484.505 228.96 475.481 228.96C463.961 228.96 453.401 227.136 443.801 223.488C434.201 219.84 425.945 214.56 419.033 207.648C412.313 200.736 407.033 192.48 403.193 182.88C399.353 173.088 397.433 162.144 397.433 150.048C397.433 139.104 399.257 128.832 402.905 119.232C406.553 109.44 411.641 100.992 418.169 93.888C424.889 86.592 432.857 80.928 442.073 76.896C451.481 72.672 461.945 70.56 473.465 70.56ZM503.129 135.648V135.36C503.129 114.432 500.825 99.072 496.217 89.28C491.801 79.296 484.601 74.304 474.617 74.304C463.865 74.304 455.897 79.68 450.713 90.432C445.721 101.184 443.033 116.16 442.649 135.36L503.129 135.648Z M710.064 202.176C710.064 206.976 710.832 211.68 712.368 216.288C713.904 220.704 716.496 223.68 720.144 225.216V226.944H657.36V225.216C661.008 223.68 663.6 220.8 665.136 216.576C666.672 212.16 667.44 207.36 667.44 202.176V124.416C667.44 110.976 664.944 101.376 659.952 95.616C655.152 89.664 649.2 86.688 642.096 86.688C636.144 86.688 630.768 87.936 625.968 90.432C621.36 92.736 617.328 95.808 613.872 99.648V202.176C613.872 206.976 614.64 211.68 616.176 216.288C617.712 220.704 620.304 223.68 623.952 225.216V226.944H561.168V225.216C564.816 223.68 567.408 220.8 568.944 216.576C570.48 212.16 571.248 207.36 571.248 202.176V118.944C571.248 112.224 570.096 106.944 567.792 103.104C565.488 99.072 562.128 95.232 557.712 91.584V90.144L610.704 73.152H612.432V97.92C618 89.856 625.296 83.328 634.32 78.336C643.344 73.152 653.424 70.56 664.56 70.56C674.16 70.56 681.84 72.48 687.6 76.32C693.552 80.16 698.16 85.056 701.424 91.008C704.88 96.96 707.184 103.68 708.336 111.168C709.488 118.464 710.064 125.76 710.064 133.056V202.176Z M814.903 70.56C826.807 70.56 836.983 72.288 845.431 75.744C854.071 79.008 861.079 83.616 866.455 89.568C872.023 95.328 876.151 102.144 878.839 110.016C881.527 117.696 882.871 126.048 882.871 135.072V138.816H784.087C784.087 148.224 785.143 157.152 787.255 165.6C789.559 173.856 792.823 181.152 797.047 187.488C801.463 193.632 806.839 198.528 813.175 202.176C819.703 205.824 827.095 207.648 835.351 207.648C842.647 207.648 850.039 206.4 857.527 203.904C865.015 201.408 872.119 196.032 878.839 187.776L879.703 189.216C876.823 194.592 873.655 199.68 870.199 204.48C866.743 209.28 862.519 213.504 857.527 217.152C852.727 220.8 846.967 223.68 840.247 225.792C833.719 227.904 825.943 228.96 816.919 228.96C805.399 228.96 794.839 227.136 785.239 223.488C775.639 219.84 767.383 214.56 760.471 207.648C753.751 200.736 748.471 192.48 744.631 182.88C740.791 173.088 738.871 162.144 738.871 150.048C738.871 139.104 740.695 128.832 744.343 119.232C747.991 109.44 753.079 100.992 759.607 93.888C766.327 86.592 774.295 80.928 783.511 76.896C792.919 72.672 803.383 70.56 814.903 70.56ZM844.567 135.648V135.36C844.567 114.432 842.263 99.072 837.655 89.28C833.239 79.296 826.039 74.304 816.055 74.304C805.303 74.304 797.335 79.68 792.151 90.432C787.159 101.184 784.471 116.16 784.087 135.36L844.567 135.648Z"
            ></path>
          </svg>
          <span class="sr-only">Sivene</span>
          {{ $t("common.by") }}
          <svg data-icon viewBox="0 0 14 14">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.99597 2.99589C5.82968 1.6324 3.88481 1.26562 2.42353 2.51417C0.962252 3.76272 0.756524 5.85024 1.90407 7.3269C2.85819 8.55465 5.74566 11.1441 6.69202 11.9822C6.7979 12.0759 6.85083 12.1228 6.91258 12.1412C6.96648 12.1573 7.02545 12.1573 7.07935 12.1412C7.1411 12.1228 7.19403 12.0759 7.29991 11.9822C8.24627 11.1441 11.1337 8.55465 12.0879 7.3269C13.2354 5.85024 13.0548 3.74959 11.5684 2.51417C10.082 1.27876 8.16225 1.6324 6.99597 2.99589Z"
              fill="#DA4742"
              stroke="#BE0005"
              stroke-width="1.16667"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          {{ $t("common.madeWith") }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
  const { t } = useI18n()

  const social = [
    { link: "https://instagram.com/zimmerhotels", icon: "ri:instagram-line", title: "Instagram" },
    { link: "https://facebook.com/zimmerhotelbosphorus", icon: "ri:facebook-fill", title: "Facebook" }
  ]

  const menuGroups = computed(() => [
    {
      title: t("footer.zimmerHotels"),
      links: [
        { title: t("footer.about"), link: "/about" },
        { title: t("footer.membershipAgreementLink"), link: "/page/uyelik-sozlesmesi" },
        { title: t("footer.privacyPolicy"), link: "/page/gizlilik-sozlesmesi" },
        { title: t("footer.kvkkLink"), link: "/page/kisisel-verilerin-korunmasi-ve-islenmesi" },
        { title: t("footer.cookiePolicy"), link: "/page/cerez-politikasi" }
      ]
    },
    {
      title: t("footer.rooms"),
      links: [
        { title: t("roomTypes.suite.title"), link: "/rooms/suite" },
        { title: t("roomTypes.deluxe.title"), link: "/rooms/deluxe" },
        { title: t("roomTypes.standart.title"), link: "/rooms/standart" },
        { title: t("roomTypes.family.title"), link: "/rooms/family" }
      ]
    },
    {
      title: t("footer.discover"),
      links: [
        { title: t("footer.events"), link: "/explore/event" },
        { title: t("footer.exploreCity"), link: "/explore" },
        { title: t("footer.cityTransportation"), link: "/transportation" },
        { title: t("footer.transferService"), link: "/transfer" }
      ]
    },
    {
      title: t("footer.dining"),
      links: [
        { title: t("diningTypes.lulu.title"), link: "/explore/detail/lulu" },
        { title: t("diningTypes.pitza.title"), link: "/explore/detail/pitza" }
      ]
    },
    {
      title: t("footer.contactGroup"),
      links: [
        { title: t("footer.humanResources"), link: "/human-resources" },
        { title: t("footer.addressPhone"), link: "/contact" }
      ]
    }
  ])

  const email = ref("")
  const termsAccepted = ref(false)

  const submitNewsletter = () => {
    // Handle newsletter logic
    console.log("Subscribe", email.value, termsAccepted.value)
  }
</script>

<style lang="scss" scoped>
  .footer {
    background: #fff;
    overflow: hidden;

    &-main {
      padding: 56px 0 40px 0;

      &__container {
        gap: 56px;
        display: flex;
        flex-direction: column;
      }
      &__top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-logo {
          height: 44px;
        }
        &-social {
          gap: 10px;
          display: flex;
          align-items: center;

          span {
            color: rgba(0, 0, 0, 0.9);
            font-size: 14px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: -0.14px;
            margin-right: 2px;
          }
          a {
            display: flex;
            width: 36px;
            height: 36px;
            justify-content: center;
            align-items: center;
            border-radius: 100px;
            background: #282828;
            font-size: 20px;
            color: #ffffff;
            flex: none;
          }
        }
      }
      &__navigation {
        display: flex;
        gap: 44px;
      }
      &__group {
        display: flex;
        flex-direction: column;
        gap: 16px;

        &-title {
          @apply font-display;
          color: #000;
          font-size: 14px;
          font-weight: 600;
          line-height: 16px;
          letter-spacing: 0.14px;
          text-transform: uppercase;
        }
        &-links {
          gap: 12px;
          display: flex;
          flex-direction: column;
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            a {
              color: #282828;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              letter-spacing: -0.14px;
              text-transform: capitalize;
            }
          }
        }
      }
      &__content {
        display: flex;
        gap: 68px;
      }
      &__newsletter {
        flex: 1;
        gap: 12px;
        display: flex;
        flex-direction: column;
        padding-left: 24px;

        &-label {
          @apply font-display;
          color: #000;
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: 0.28px;
          text-transform: uppercase;
        }
        &-input {
          display: flex;
          align-items: center;

          :deep(input) {
            width: 100%;
          }
          :deep(button) {
            width: 56px;
            height: 56px;

            --button-padding: 0;
            --button-font-size: 20px;
          }
        }
      }
    }
    &-bottom {
      background: #f2f0e9;
      padding-bottom: env(safe-area-inset-bottom);

      &__container {
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      &__copyright {
        color: #61646c;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.32px;
      }
      &__agency {
        color: #61646c;
        direction: ltr;
        margin: -1rem;
        display: flex;
        flex: none;
        align-items: center;
        justify-content: center;
        gap: 0.375rem;
        padding: 0.75rem 1rem;
        font-size: 1rem;
        line-height: 1.5rem;

        [data-logo] {
          color: #000;
          width: auto;
          height: 0.75rem;
        }

        [data-icon] {
          margin-left: -0.125rem;
          margin-right: -0.125rem;
          width: 0.875rem;
          height: auto;
        }
      }
    }

    @include media("xl") {
      &-main {
        &__navigation {
          gap: 32px;
        }
        &__content {
          gap: 32px;
        }
        &__newsletter {
          padding-left: 0;
        }
      }
    }
    @include media("lg") {
      &-main {
        &__content {
          gap: 48px;
          flex-direction: column-reverse;
        }
      }
    }
    @include media("md") {
      &-main {
        &__navigation {
          gap: 28px 24px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
        }
        &__group {
          width: 100%;
        }
        &__newsletter {
          &-input {
            :deep(button) {
              width: 50px;
              height: 50px;
            }
          }
        }
      }
      &-bottom {
        &__container {
          flex-direction: column;
          text-align: center;
          gap: 4px;
          height: auto;
          padding-top: 12px;
          padding-bottom: 12px;
        }
        &__copyright {
          font-size: 14px;
          width: 100%;
        }
        &__agency {
          font-size: 14px;
          padding: 0;
          margin: 0;
          gap: 8px;
          flex-wrap: wrap;
          width: 100%;

          [data-logo] {
            height: 0.75rem;
            padding-bottom: 1px;
          }
        }
      }
    }
    @include media("sm") {
      &-main {
        padding: 28px 0 24px;

        &__container {
          gap: 28px;
        }
        &__top {
          gap: 12px;
          flex-direction: column;
        }
        &__content {
          gap: 32px;
        }
        &__group {
          gap: 12px;

          &-links {
            gap: 10px;
          }
        }
      }
      &-main {
        &__navigation {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
</style>
